import ModalExtendNotify from "pages/renewcert/components/ModalExtendNotify/ModalExtendNotify";

export default ModalExtendNotify